import { render } from "./UserRecurrings.vue?vue&type=template&id=886d7c72"
import script from "./UserRecurrings.vue?vue&type=script&lang=js"
export * from "./UserRecurrings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__